import * as API from './index'

export default {
    add: params => {
        return API.POST('/api/MatchCategory/Add', params)
    },
    delete: params => {
        return API.DELETE('/api/MatchCategory/delete', params)
    },
    deleteMusic:params=>{
        return API.DELETE('/api/MatchCategory/DeleteMusic', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/matchcategory.js